import bluebird from 'bluebird'
import CreateReducer from '../utils/createReducer'
import CreateActions from '../utils/createActions'

import {
  handlers,
} from '../utils/api'

import networkWrapper from '../utils/networkWrapper'
import projectSelectors from '../selectors/project'
import routerActions from './router'
import bookingformActions from './bookingform'
import bookingActions from './booking'
import snackbarActions from './snackbar'

const prefix = 'project'
const wrapper = networkWrapper.factory(prefix)

const initialState = {
  projects: [],
  userRole: 'none',
  currentProjectId: null,
  users: [],
  switchingProject: false,
}

const reducers = {
  setProjects: (state, action) => {
    state.projects = action.payload
  },
  setProject: (state, action) => {
    const project = action.payload
    state.projects = state.projects.filter(p => p.id != project.id).concat([project])
  },
  setUserRole: (state, action) => {
    state.userRole = action.payload
  },
  setUsers: (state, action) => {
    state.users = action.payload
  },
  setCurrentProjectId: (state, action) => {
    state.currentProjectId = action.payload
  },
  stashAdminProjectId: (state, action) => {
    localStorage.setItem('projectId', action.payload)
  },
  setSwitchingProject: (state, action) => {
    state.switchingProject = action.payload
  },
}

const sideEffects = {

  loadAdminProjects: () => wrapper('loadAdminProjects', async (dispatch, getState) => {
    const data = await handlers.get(`/admin/projects`)
    dispatch(actions.setProjects(data))
    const stashedId = localStorage.getItem('projectId') || projectSelectors.currentProjectId(getState())
    let stashedProject = data.find(p => p.id == stashedId)
    if(!stashedProject && data.length > 0) {
      stashedProject = data[0]
    }
    if(stashedProject) {
      dispatch(actions.setCurrentProjectId(stashedProject.id))
      dispatch(actions.stashAdminProjectId(stashedProject.id))
    }
    else {
      dispatch(actions.stashAdminProjectId(''))
    }
  }, {
    globalLoading: false,
  }),

  loadPublicProjects: () => wrapper('loadPublicProjects', async (dispatch, getState) => {
    const data = await handlers.get(`/booking/projects`)
    dispatch(actions.setProjects(data))
  }, {
    globalLoading: false,
  }),

  loadPublicProject: (id) => wrapper('loadPublicProject', async (dispatch, getState) => {
    const data = await handlers.get(`/booking/projects/${id}`)
    dispatch(actions.setProjects([data]))
  }, {
    globalLoading: false,
  }),

  switchProject: (id, redirectToBookingForms = true) => wrapper('switchProject', async (dispatch, getState) => {
    if(redirectToBookingForms) {
      dispatch(routerActions.navigateTo('admin.bookingforms.list', {}))    
      await bluebird.delay(100)
    }
    dispatch(actions.setCurrentProjectId(id))
    dispatch(actions.stashAdminProjectId(id))
    dispatch(actions.loadUserRole())
    dispatch(bookingformActions.loadAdminBookingforms())
    dispatch(bookingActions.loadProject({
      id,
    }))
    dispatch(bookingActions.setCalendar([]))
    dispatch(bookingActions.setCurrentBookingform(null))
    dispatch(bookingActions.setConfig(null))
  }),

  loadUserRole: () => wrapper('loadUserRole', async (dispatch, getState) => {
    const project = projectSelectors.currentProjectId(getState())
    const data = await handlers.get(`/admin/projects/${project}/user_role`)
    dispatch(actions.setUserRole(data.role))
  }, {
    globalLoading: false,
  }),

  loadUsers: () => wrapper('loadUsers', async (dispatch, getState) => {
    const project = projectSelectors.currentProjectId(getState())
    const data = await handlers.get(`/admin/projects/${project}/users`)
    dispatch(actions.setUsers(data))
  }),

  createUser: (payload) => wrapper('createUser', async (dispatch, getState) => {
    const project = projectSelectors.currentProjectId(getState())
    await handlers.post(`/admin/projects/${project}/users`, payload)
    await dispatch(actions.loadUsers())
    dispatch(snackbarActions.setSuccess('user created'))
    return true
  }),

  updateUser: (id, payload) => wrapper('updateUser', async (dispatch, getState) => {
    const project = projectSelectors.currentProjectId(getState())
    await handlers.put(`/admin/projects/${project}/users/${id}`, payload)
    await dispatch(actions.loadUsers())
    dispatch(snackbarActions.setSuccess('user updated'))
    return true
  }),

  deleteUser: (id) => wrapper('deleteUser', async (dispatch, getState) => {
    const project = projectSelectors.currentProjectId(getState())
    await handlers.delete(`/admin/projects/${project}/users/${id}`)
    await dispatch(actions.loadUsers())
    dispatch(snackbarActions.setSuccess('user deleted'))
    return true
  }),

}

const reducer = CreateReducer({
  initialState,
  reducers,
  prefix,
})

const actions = CreateActions({
  reducers,
  sideEffects,
  prefix,
})

export { actions, reducer }
export default actions